import mindmap from "./mindmap";
import konvaCanvas from "./konvaCanvas";
import PvPgame from "./PvPgame";
import Molegame from "./Molegame";
import PvPTFgame from "./PvPTFgame";
import HTwbActKitHome from "./HTwbActKitHome";
import htwbcard from "./htwbcard";
import PickGame from "./PickGame";
import PunchBoard from "./PunchBoard";
import aiprompt from "./aiprompt";
import gameActManager from "./gameActManager";
import Snakegame from "./Snakegame";
import Mazegame from "./Mazegame";
export default {
  HTwbActKitHome,
  konvaCanvas,
  mindmap,
  PvPgame,
  Molegame,
  PvPTFgame,
  htwbcard,
  PickGame,
  PunchBoard,
  aiprompt,
  gameActManager,
  Snakegame,
  Mazegame,
  Game: {
    pushSuccess: "游戏已推送成功，并可在游戏管理页面检视",
    pushFailed: "推送失败：{message}",
    tokenRefreshing: "Token 即将刷新，请稍后重试",
    repush: "重新推送",
    settingsUnchanged: "设定未变动，不需重新推送",
    gameLoading: "准备中..."
  },
  refreshToken: "刷新token",
  確定: "确定",
  取消: "取消",
  //Navigator
  測試: "测试",
  HT資源網: "HT资源网",
  布題頁面: "HiTeach5 布题页面",
  音訊: "音讯",
  影片: "影片",
  背景圖: "背景图",
  測驗卷: "测验卷",
  教材:"教材",
  教案:"教案",
  後台管理: "后台管理",
  檢舉管理: "检举管理",
  所有上傳管理: "所有上传管理",
  管理者後台: "管理者后台",
  登入: "登入",
  設定: "设定",
  登出: "登出",
  搜尋: "搜索...",
  暫無資料: "暂无资料",
  推薦教材: "推荐教材",
  的搜尋結果: "的搜索结果...",
  分類: "分类",
  全部: "全部",
  年級: "年级",
  科目: "科目",
  排序: "排序",
  時間: "时间",
  標題: "标题",
  附件: "附件",
  無法播放的格式: "无法播放的格式",
  直接下載提示字: "目前无法以播放器预览之格式，请直接下载",

  下载: "下载",
  簡介: "简介",
  上傳者: "上传者",
  相關教材: "相关教材",
  個人簡介: "个人简介",
  已貢獻教材數: "已贡献教材数",
  被管理員設置為隱藏之教材: "被管理员设置为隐藏之教材",
  簡介文字: "简介文字",
  儲存: "储存",
  更新: "更新",
  語系: "语系",
  //檢舉頁面
  檢舉管理時間: "举报管理-时间",
  檢舉管理教材: "举报管理-教材",
  檢舉搜尋提示時間: "仅可搜索被举报上传者姓名、举报者姓名，教材标题栏位...",
  檢舉搜尋提示教材: "仅可搜索被举报上传者姓名、教材标题栏位",
  檢視模式: "检视模式:",
  按時間近到遠: "按时间近到远",
  按教材ID匯總: "按教材ID汇总",
  未處理: "未处理",
  已處理: "已处理",
  未隱藏: "未隐藏",
  已隱藏: "已隐藏",
  檢舉時間: "举报时间",
  檢舉流水號: "举报流水号",
  檢舉者: "举报者",
  檢舉代碼: "举报代码",
  檢舉理由: "举报理由",
  審批狀態: "审批状态",
  審批時間: "审批时间",
  接受: "接受",
  不受理: "不受理",
  編輯: "编辑",
  刪除: "删除",
  刪除提示: "删除提示",
  刪除提示內文: "确定删除这份教材吗? 删除后将无法复原!",

  一鍵接受: "一键接受",
  一鍵不受理: "一键不受理",
  檢舉: "举报",

  //常用material欄位
  教材Id: "教材Id",
  類型: "类型",
  點擊數: "点击数",
  授課語系: "授课语系",
  標籤: "标签",
  隱藏: "隐藏",

  //Msg
  更新成功: "更新成功!",
  刪除成功: "删除成功!",

  "reportmsg-form": {
    檢舉教材表單: "举报教材表单",
    檢舉教材名稱: "举报教材名称",
    檢舉原因: "举报原因",
    錯誤或無法使用的檔案格式: "错误或无法使用的文件格式",
    有害或誤導性的內容: "有害或误导性的内容",
    侵權內容: "侵权内容",
    其他原因: "其他原因",
    描述: "描述",
    敘明原因提示字: "本检举表单会根据您的登入帐号留下纪录，请务必叙明原因，提供管理人员审查是否属实",
    送出: "提交",
    取消: "取消",
  },
  "editmaterial-form": {
    編輯教材資訊: "编辑教材资讯",
    標題: "标题",
    介紹: "介绍",
    年級: "年级",
    未指定: "未指定",
    科目: "科目",
    授課語系: "授课语系",
    自訂標籤: "自订标签",
    標籤提示字: "*请用逗号分隔，例如：二元一次方程式，三角函数",
  },
  webirs:{
   //konva畫板字串
   konvaCanvas: {
    比例: '比例',
    //AddImageBox
    檔案圖片: '文件图片',
    素材庫:'素材库',
    選取圖片作為物件: '选取图片作为对象',
    背景設置: '背景设置',
    選取圖片作為背景: '选取图片作为背景',
    //AddTextBox & TextSetting
    文字工具: '文字工具',
    編輯文字便利貼:'编辑',
    "openURL_NewTab": "于新分页检视连结",
    刪除文字便利貼:'删除',
    複製文字便利貼:'克隆',
    輸入文字: '输入文字',
    字體大小: '字体大小',
    字體顏色:'字体颜色',
    顏色: '颜色',
    便利貼顏色:'便利贴颜色',
    確定: '确定',
    取消: '取消',
    //PenSetting
    畫筆: '画笔',
    通用畫筆: '通用画笔',
    高光筆: '高光笔',
    鐳射筆: '镭射笔',
    大小:'大小',
    //ShapeSetting
    圖形: '图形',
    邊框: '边框',
    填充: '填充',
    箭頭: '箭头',
    直線: '直线',
    圓形: '圆形',
    橢圓: '椭圆',
    矩形: '矩形',
    三角形: '三角形',
    星形: '星形',
    所選圖片過大:'所选图片过大(应小于3MB)，请重新选择！',
    打開點擊的物件連結:'打开点击的对象连结?',
    多連結詢問:'侦测到点击的对象含有多个有效连结，请选择一个动作',
    目前沒有動作可復原: '目前没有动作可复原',
    復原我最近一次刪除動作:'复原我最近一次删除动作!',
    ModifyHint: '内容有修改过，离开将不保存，您还想离开吗？',
    物件化畫板:'对象化画板',
    重新整理圖層:'重新整理图层!', 
    刪除鎖定物件提示字:'删除了教师锁定的对象，可点击复原或重开教材!',
    協作無法刪除鎖定提示字:'协作无法删除教师锁定的物件!',
    複製:'克隆',
    刪除:'删除',
    移到最上層:'移到最上层',
    移到最下層:'移到最下层',
    回放中:'回放中...',
    暫停:'暂停',
    標準:'标准',
    快速:'快速',
    教師:"教师"
  },
  mindmap:{
    新增:'新增节点',
    編輯:'编辑节点',
    輸入文字: '输入文字',
    確定:'确定',
    取消:'取消',
    請先選取節點:'请先选取节点!',
    不可刪除有子項目的節點:'不可刪除有子項目的節點!',
    新增失敗:'新增失败，父节点已被删除!',
    編輯失敗:'编辑失败，所选节点已被删除!',
    加入根節點:'加入根节点',
    左邊: '左边',
    右邊: '右边',
    已是最上面:'已是最上面!',
    已是最下面:'已是最下面!',
    圖片:'图片',
    圖片過大提示字1:'所选图片过大(请小于',
    圖片過大提示字2:'MB)，请重新选择！',
    連結:'连结',
    連結網址:'连结网址',
    連結名稱:'连结名称',
    輸入URL:'输入URL...',
    輸入連結名稱:'输入连结名称...',
    註解:'注解',
    進階設定:'进阶设置',
    線條顏色:'线条颜色',
    節點顏色:'节点颜色',
    markDownNoData: '转换后无有效节点资料!',
    markDownErr:'所提供的Markdown资料无法转换!',
    preEditHint:'注意：目前的节点之前编辑者是',
    confirmUpdate:'，确定要修改吗?',
    moveNodeTitle:'移动节点',
    moveNodeHint:'请选择父节点',
    noTopic:'无主题',
    share:'上云',
    createSuccess:'MindMap 创建成功，准备跳转',
    initSharingFailed:'分享初始化失败，请重试',
    authError:'请重试翻页尝试更新授权',
    unexpectedError:'发生未预期的错误，请重试',
    menu:{
      新增:'新增',
      刪除:'删除',
      上移:'上移',
      下移:'下移',
      左移:'左移',
      右移:'右移',
      編輯:'编辑',
      複製:'复制',
      檢視圖片:'检视图片',
      最後更新:'最后更新',
      檢視節點變更記錄:'检视节点变更记录',
      lock:'锁定',
      unlock:'解锁',
      move:'移动',
      applyColor:'套用色彩',
      allRightLayout:'全向右布局',
      allRightLayoutSuccess:'已将所有第一层子节点调整为右侧布局',
      allLeftLayout:'全向左布局',
      allLeftLayoutSuccess:'已将所有第一层子节点调整为左侧布局',
      noChildrenToApply:'根节点没有子节点可以套用',
      expandAll:'全展开',
      collapseAll:'全收合',
    },
    treeMenu:{
      currentMoveNode:'要移动的节点 (包含子节点)',
      selectedParentNode:'选取为父节点'
    },
    imgEditor:{
      詢問離開動作:"询问离开动作?",
      保存圖片:'保存图片',
      捨棄變更:'舍弃变更',
      取消:'取消',
    },
    nodeHistory:{
      節點歷史:'节点历史',
      動作:'动作',
      編輯者:'编辑者',
      內容:'内容',
      線條顏色:'线条颜色',
      節點顏色:'节点颜色',
      註解:'注解',
      add:'新增',
      update:'更新',
    },
    askJumpSharing: {
      title: '要使用Sharing网站-云端的思维导图吗？',
      confirm: '确定',
      cancel: '取消',
    }
  }
}
};
